// authSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { handleTonnageMasterSingleList } from "../../../Api/api";

// Define an initial state for the slice
const initialState = {
   data: null,
   loading: false,
   error: null,
};



// Create an async thunk for the login action
export const tonnageMasterSingleListAsync = createAsyncThunk(
   "tonnageMaster/getList",
   async ({ data, done, err }) => {
      // ;
      try {
         const { id} = data;
       //  const response = await handleCompanyMasterSingleList(id, modelId, actionId);
         const response = await handleTonnageMasterSingleList(id);
         done && done(response.data.res);
         return response.data;
      } catch (error) {
         // You can customize the error handling here
         
         err && err();
         throw error.response.data;
      }
   }
);

// Create a slice of the Redux store
const tonnageMasterSingleListSlice = createSlice({
   name: "tonnageMaster",
   initialState,
   reducers: {
      // You can define additional synchronous actions here if needed
   },
   extraReducers: (builder) => {
      builder
         .addCase(tonnageMasterSingleListAsync.pending, (state) => {
            state.loading = true;
            state.error = null;
         })
         .addCase(tonnageMasterSingleListAsync.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            // 
         })
         .addCase(tonnageMasterSingleListAsync.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload; // error message from the rejectWithValue call
         });
   },
});

// Export the reducer
export default tonnageMasterSingleListSlice.reducer;
